<div class="export-day-modal">
  <h3 class="export-day-modal__title">
    {{ modalData.titleTranslateKey | translate }}
  </h3>

  @if (modalData.earliestDate) {
    <lib-date-picker
      class="export-day-modal__picker"
      mode="single"
      [minDate]="modalData.earliestDate"
      [maxDate]="modalData.latestDate"
      [placeholder]="'monitoring.select-date' | translate"
      [formControl]="dayControl"
    />
  } @else {
    <p class="export-day-modal__empty">
      {{ 'monitoring.export-day.nothing-selectable' | translate }}
    </p>
  }

  <div class="export-day-modal__buttons">
    <lib-button
      buttonStyle="transparent-tertiary"
      buttonSize="large"
      (click)="cancel()"
    >
      {{ 'monitoring.cancel' | translate }}
    </lib-button>

    <lib-button
      buttonSize="large"
      [disabled]="!selectedDay"
      (click)="confirm()"
    >
      {{ 'monitoring.export-day.confirm' | translate }}
    </lib-button>
  </div>
</div>
